// Central content + asset references for the LELESKYE site.

export const IMAGES = {
  // Provided athlete photos
  cutout: "https://customer-assets.emergentagent.com/job_495a68eb-7495-4867-bcae-827084dfbfb7/artifacts/496g9y4k_IMG_6954.png",
  running: "https://customer-assets.emergentagent.com/job_495a68eb-7495-4867-bcae-827084dfbfb7/artifacts/nc5f67z4_IMG_6948.jpeg",
  blockStance: "https://customer-assets.emergentagent.com/job_495a68eb-7495-4867-bcae-827084dfbfb7/artifacts/u8mg4y7q_IMG_6949.jpeg",
  portrait: "https://customer-assets.emergentagent.com/job_495a68eb-7495-4867-bcae-827084dfbfb7/artifacts/d5rzq88p_IMG_6947.jpeg",
  medals: "https://customer-assets.emergentagent.com/job_495a68eb-7495-4867-bcae-827084dfbfb7/artifacts/2sol7gbc_IMG_6957.jpeg",
  // New photos
  headshot: "https://customer-assets.emergentagent.com/job_leah-thames/artifacts/0dkuuxal_IMG_6941.jpeg",
  studioStanding: "https://customer-assets.emergentagent.com/job_leah-thames/artifacts/0pbh0nfb_IMG_6944.jpeg",
  indoorRun: "https://customer-assets.emergentagent.com/job_leah-thames/artifacts/x1z020ft_IMG_6951.jpeg",
  graduation: "https://customer-assets.emergentagent.com/job_leah-thames/artifacts/6upw3xj9_IMG_6952.jpeg",
  // Latest high-res photos (2026)
  headshotStudio: "https://customer-assets.emergentagent.com/job_leah-thames/artifacts/p1exucrs_IMG_7245.jpeg",
  blockStart: "https://customer-assets.emergentagent.com/job_leah-thames/artifacts/ty54kayc_IMG_7243.jpeg",
  relayBW: "https://customer-assets.emergentagent.com/job_leah-thames/artifacts/iyfplkp4_IMG_7240.jpeg",
  podiumMVP: "https://customer-assets.emergentagent.com/job_leah-thames/artifacts/39bh2g5n_IMG_7242.jpeg",
  finishWin: "https://customer-assets.emergentagent.com/job_leah-thames/artifacts/iuqoijiu_IMG_7244.jpeg",
  // Brand sunset backgrounds
  heroBg: "https://static.prod-images.emergentagent.com/jobs/495a68eb-7495-4867-bcae-827084dfbfb7/images/1e5f2eab71659d70483b040719e1de568d5181edc3a1b2de23e5a142142ba02d.png",
  sunsetTrack: "https://static.prod-images.emergentagent.com/jobs/495a68eb-7495-4867-bcae-827084dfbfb7/images/1e5f2eab71659d70483b040719e1de568d5181edc3a1b2de23e5a142142ba02d.png",
  sunsetSky: "https://customer-assets.emergentagent.com/job_leah-thames/artifacts/9ng1ex08_IMG_6961.png",
  ctaClouds: "https://customer-assets.emergentagent.com/job_leah-thames/artifacts/9ng1ex08_IMG_6961.png",
  // Lifestyle / stock
  wellness: "https://images.unsplash.com/photo-1567013514336-6de53c9e7e63?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  reading: "https://images.unsplash.com/photo-1666813721996-42956e40788e?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  trackCurve: "https://images.unsplash.com/photo-1768380075222-c0ed728baae2?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  travelFountain: "https://images.unsplash.com/photo-1779832429084-f56db7e61a4a?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  travelCity: "https://images.unsplash.com/photo-1762343041197-3a2c5d66669e?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
};

export const NAV_LINKS = [
  { label: "Home", id: "home" },
  { label: "About", id: "about" },
  { label: "Athletics", id: "athletics" },
  { label: "The Journey", id: "journey" },
  { label: "Newsroom", id: "news" },
  { label: "Blog", id: "blog" },
  { label: "Partnerships", id: "partnerships" },
  { label: "Sponsors", id: "sponsors", to: "/sponsors" },
  { label: "Contact", id: "contact" },
];

export const METRICS = [
  { value: "10K+", label: "Monthly Video Views" },
  { value: "500+", label: "Average Instagram Engagements" },
  { value: "20%+", label: "Average Engagement Rate" },
  { value: "200+", label: "Newsletter Subscribers" },
];

export const BY_THE_NUMBERS = [
  { icon: "play", value: "10K+", label: "Monthly Video Views" },
  { icon: "heart", value: "500+", label: "Avg. Instagram Engagements" },
  { icon: "bar", value: "20%+", label: "Average Engagement Rate" },
  { icon: "eye", value: "200+", label: "Newsletter Subscribers" },
];

export const SNAPSHOT_HONORS = [
  "Growing Website & Email Community",
  "NCAA Championship Qualifier",
  "2025 Missouri Valley Conference Most Valuable Female Athlete",
];

export const CONTENT_PILLARS = [
  { icon: "performance", title: "Performance", desc: "Training, racing, workouts, and the pursuit of excellence." },
  { icon: "lifestyle", title: "Lifestyle", desc: "Fashion, travel, routines, and life beyond the track." },
  { icon: "wellness", title: "Wellness", desc: "Recovery, nutrition, habits, and mindset." },
  { icon: "food", title: "Food & Culinary", desc: "Recipes, meal prep, and the connection between food and fuel." },
  { icon: "journey", title: "The Journey", desc: "Building a professional career in real time." },
];

export const HONORS = [
  "NCAA Championship Qualifier",
  "2025 Missouri Valley Conference Most Valuable Female Athlete",
];

export const SPONSOR_TIERS = [
  {
    name: "Community Sponsor",
    tag: "Community",
    price: "$250",
    period: "/ year",
    desc: "For businesses looking to support a local professional athlete.",
    perks: [
      "Logo featured on Leah's website",
      "Welcome Instagram Story shoutout",
      "Recognition in a quarterly sponsor appreciation post",
      "Digital \"Proud Supporter of Leah\" badge",
    ],
    highlight: false,
  },
  {
    name: "Performance Sponsor",
    tag: "Performance",
    price: "$500",
    period: "/ year",
    desc: "Elevated visibility with dedicated content and placement.",
    perks: [
      "Everything in Community, plus",
      "One dedicated social media post featuring your business",
      "Sponsor Spotlight on Leah's website with description and link",
      "Business tagged in relevant content throughout the year",
      "Personalized signed photo for display",
    ],
    highlight: false,
  },
  {
    name: "Champion Sponsor",
    tag: "Best Value",
    price: "$1,000",
    period: "/ year",
    desc: "Full partnership with in-person presence and premium content.",
    perks: [
      "Everything in Performance, plus",
      "One professionally produced Instagram Reel featuring your business",
      "One local appearance (employee event, customer appreciation, youth clinic, or grand opening — up to 1 hour)",
      "Quarterly sponsor recognition on Instagram Stories",
      "First right of renewal each year",
    ],
    highlight: true,
  },
];

export const MEDIA_KIT_URL = "https://customer-assets.emergentagent.com/job_leah-thames/artifacts/lp55bmq3_Leah_Thames_Media_Kit_2.pdf";

export const SPONSORSHIP_GUIDE_URL = "https://customer-assets.emergentagent.com/job_leah-thames/artifacts/usf70imb_Sponsor_Leah_Thames_Guide_v2.pdf";

export const SPONSORSHIP = {
  heading: "Be Part of My Journey",
  paragraphs: [
    "Every race starts long before I step onto the track. It takes countless hours of training, travel, preparation, and the support of people who believe in what I'm working toward.",
    "As I continue pursuing my goals in professional track, I'm grateful for the businesses and individuals who choose to be part of my journey. Your support helps make it possible for me to train, compete, and represent my community at the highest level.",
    "If you're looking for a meaningful way to support a local athlete while gaining visibility for your business, I'd love to connect with you.",
  ],
  ctaTitle: "Interested in Becoming a Sponsor?",
};

export const ATHLETIC_PROFILE = {
  primaryEvent: "400m & 200m",
  personalBest: "51.54",
  personalBest200: "22.69",
  specialty: "4x400 Relay",
  availableFor: [
    "Professional Track Clubs",
    "Domestic & International Competition",
    "Relay Opportunities",
    "Community Events",
    "Brand Partnerships",
  ],
  highlights: [
    "2025 Missouri Valley Conference Outdoor Most Valuable Female Athlete",
    "2026 MVC Outdoor Champion, 200m & 400m",
    "NCAA Championship Qualifier (400m)",
    "400m PB: 51.54  ·  200m PB: 22.69",
    "SIU Program Record Holder",
    "Multiple-Time MVC Individual Champion",
  ],
};

export const CORE_VALUES = [
  "Excellence",
  "Authenticity",
  "Confidence",
  "Discipline",
  "Growth",
  "Community",
  "Empowerment",
];

export const REEL_CATEGORIES = [
  "Race Day",
  "Training",
  "Pink Spikes Diaries",
  "What I Eat as a Professional Runner",
  "Travel",
  "Life Beyond The Track",
];

export const PARTNERSHIP_WAYS = [
  "Brand Ambassadorships",
  "Sponsored Content",
  "Social Campaigns",
  "Product Integrations",
  "Speaking Engagements",
  "Event Appearances",
  "Community Initiatives",
];

export const PARTNER_CATEGORIES = [
  "Athletic Apparel",
  "Wellness & Recovery",
  "Beauty & Self-Care",
  "Food & Nutrition",
  "Lifestyle & Travel",
  "Women's Empowerment",
];

export const MEDIA_KIT_ITEMS = [
  { title: "Media Kit", desc: "Full brand & partnership overview deck." },
  { title: "Athletic Resume", desc: "Career results, PRs, and honors." },
  { title: "Professional Headshots", desc: "High-resolution studio portraits." },
  { title: "Action Photos", desc: "Competition & training imagery." },
  { title: "Biography", desc: "Short & long-form bios for press use." },
  { title: "Brand Assets", desc: "LELESKYE logos & color palette." },
  { title: "Partnership Deck", desc: "Ways to work together & rate guide." },
];
